import en from './locale/en';
import pt_BR from './locale/pt_BR';

// The dashboard ships only the languages offered by Talkvia.
export default { en, pt_BR };
